/**
 * Disposition captures WHY a job opportunity stopped progressing or closed.
 * It is metadata only and intentionally separate from application Status.
 * Disposition applies ONLY to application records (boardType === 'application').
 * It is optional — null/undefined is the normal state for most applications.
 * @enum {string}
 */
export const Disposition = Object.freeze({
  NOT_SELECTED: 'not_selected',
  LOCATION: 'location',
  COMPENSATION: 'compensation',
  TIMING: 'timing',
  ROLE_CLOSED: 'role_closed',
  WITHDREW: 'withdrew',
  OTHER: 'other',
});

/** Ordered list for display in selects/filters */
export const DISPOSITION_ORDER = [
  Disposition.NOT_SELECTED,
  Disposition.LOCATION,
  Disposition.COMPENSATION,
  Disposition.TIMING,
  Disposition.ROLE_CLOSED,
  Disposition.WITHDREW,
  Disposition.OTHER,
];

/** Display labels for each disposition */
export const DISPOSITION_LABELS = Object.freeze({
  [Disposition.NOT_SELECTED]: 'Not Selected',
  [Disposition.LOCATION]: 'Location / On-site Requirement',
  [Disposition.COMPENSATION]: 'Compensation',
  [Disposition.TIMING]: 'Timing / Hiring Paused',
  [Disposition.ROLE_CLOSED]: 'Role Filled / Closed',
  [Disposition.WITHDREW]: 'Candidate Withdrew',
  [Disposition.OTHER]: 'Other',
});

/** Subtle one-line indicator icons for ApplicationCard */
export const DISPOSITION_ICONS = Object.freeze({
  [Disposition.NOT_SELECTED]: '✕',
  [Disposition.LOCATION]: '📍',
  [Disposition.COMPENSATION]: '💰',
  [Disposition.TIMING]: '⏸',
  [Disposition.ROLE_CLOSED]: '■',
  [Disposition.WITHDREW]: '↩',
  [Disposition.OTHER]: '•',
});

/** Set of valid disposition values for validation */
export const DISPOSITION_VALUES = Object.freeze(Object.values(Disposition));
